import { render } from "./AudioPlayerShell.vue?vue&type=template&id=33556bf4&scoped=true"
import script from "./AudioPlayerShell.vue?vue&type=script&lang=js"
export * from "./AudioPlayerShell.vue?vue&type=script&lang=js"

import "./AudioPlayerShell.vue?vue&type=style&index=0&id=33556bf4&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33556bf4"]])

export default __exports__